import React from "react";
import { CardHeader } from "./CardHeader";
import { CardContent } from "./CardContent";
import { CardActions } from "./CardActions";
import LoadingWrapper from "components/Shared/LoadingWrapper";

export const ActionCard = ({ children, loading = false, loadingText }) => {
  return (
    <LoadingWrapper {...{ loading, loadingText }}>{children}</LoadingWrapper>
  );
};

ActionCard.Header = CardHeader;

ActionCard.Content = CardContent;

ActionCard.Actions = CardActions;
